
import { Vue, Component } from 'vue-property-decorator';
import { Icon, Swipe, SwipeItem, Toast } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import Canvas from './Canvas.vue';
import qs from 'qs';
Vue.use(Icon).use(Swipe).use(SwipeItem);
@Component({
  components: {
    Canvas,
  },
})
export default class Home extends Vue {
  imgList: any = [
    { url: require('../assets/01-南天湖.jpg'), text: '南天湖' },
    { url: require('../assets/02-马拉松.jpg'), text: '马拉松' },
    { url: require('../assets/03-金佛山.jpg'), text: '金佛山' },
    { url: require('../assets/04-瞿塘峡.jpg'), text: '瞿塘峡' },
    { url: require('../assets/05-涪江.jpg'), text: '涪江' },
    { url: require('../assets/06-红池坝.jpg'), text: '红池坝' },
    { url: require('../assets/07-融创茂.jpg'), text: '融创茂' },
    { url: require('../assets/08-阿依河.jpg'), text: '阿依河' },
    { url: require('../assets/09-峨眉山.jpg'), text: '峨眉山' },
    { url: require('../assets/10-九寨沟.jpg'), text: '九寨沟' },
  ];
  id: number = 0;
  backImg: boolean = true;
  index: number = 0;
  swipe: any = [
    {
      text: '欢乐贺新春，运动迎冬奥。努力创建国家体育旅游示范区，打造全国户外运动目的地。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '继续保持奋斗姿态，努力为建设体育强市作出新贡献。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '坚定信心、团结拼搏，埋头苦干、勇毅前行，奋力推动体育强市建设迈上新台阶！祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '不要人夸颜色好，只留清气满乾坤。祝虎年大吉、万事如意，幸福安康！',
    },

    { text: '畅游巴山蜀水，乐享运动川渝。祝虎年大吉、万事如意，幸福安康！' },
    {
      text: '“川”越巴山蜀水，运动“渝”您同行。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '巴山蜀水如诗画，川渝体旅邀天下。祝虎年大吉、万事如意，幸福安康！！',
    },
    {
      text: '巴山蜀水好风光，体育旅游最时尚。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '巴山蜀水总是情，体育旅游川渝行。祝虎年大吉、万事如意，幸福安康！',
    },
  ];
  changSwipe: boolean = false;
  name: any = '';
  mounted() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
      return false;
    } else if (!isWeiXin()) {
      Toast('请在微信中打开');
      return false;
    }
    this.name = window.localStorage.getItem('nickname');
  }
  changImg(index: number) {
    this.id = index;
    this.backImg = false;
  }
  swipeChange(index: any) {
    this.index = index;
    this.changSwipe = true;
  }
  prev() {
    (this.$refs.Swipe as any).swipeTo(this.index - 1);
  }
  next() {
    (this.$refs.Swipe as any).swipeTo(this.index + 1);
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
